import React, { useEffect } from "react";
import { Box, Button, useTheme } from "@mui/material";
import { useSearchParams } from "react-router-dom";

import RegionComponent from "../../component/admin-dashboard-components/Region";
import RoleComponent from "../../component/admin-dashboard-components/Role";
import ShopComponent from "../../component/admin-dashboard-components/Shop";
import OrganizationComponent from "../../component/admin-dashboard-components/Organization";
import UserManagement from "../../component/admin-dashboard-components/user/UserManagement";
import DeviceTypeComponent from "../../component/device-components/DeviceTypeComponent";

const tabs = [
  "Region",
  "Role",
  "Organization",
  "Shop",
  "Device Type",
  "User Management",
];

const AdminDashboardPage = () => {
  const theme = useTheme();
  const [searchParams, setSearchParams] = useSearchParams();

  const tabFromURL = searchParams.get("tab");
  const defaultTab = tabs.includes(tabFromURL) ? tabFromURL : "Region";

  const [activeTab, setActiveTab] = React.useState(defaultTab);

  useEffect(() => {
    setSearchParams({ tab: activeTab });
  }, [activeTab, setSearchParams]);

  const renderActiveTab = () => {
    switch (activeTab) {
      case "Region":
        return <RegionComponent />;
      case "Role":
        return <RoleComponent />;
      case "Organization":
        return <OrganizationComponent />;
      case "Shop":
        return <ShopComponent />;
      case "Device Type":
        return <DeviceTypeComponent />;
      case "User Management":
        return <UserManagement />;
      default:
        return null;
    }
  };

  return (
    <>
      <Box className="flex gap-2 mb-4">
        {tabs.map((tab) => (
          <Box
            key={tab}
            sx={{
              borderBottom: "2px solid",
              borderColor:
                activeTab === tab
                  ? theme.palette.mode === "dark"
                    ? theme.palette.primary.main
                    : "#22C55E"
                  : "transparent",
            }}
          >
            <Button
              onClick={() => setActiveTab(tab)}
              sx={{
                textTransform: "none",
                color:
                  activeTab === tab
                    ? theme.palette.mode === "dark"
                      ? theme.palette.primary.main
                      : "#000000"
                    : "text.primary",
              }}
            >
              {tab}
            </Button>
          </Box>
        ))}
      </Box>
      {renderActiveTab()}
    </>
  );
};

export default AdminDashboardPage;
